<!-- start banner Area -->
<section class="banner-area relative" id="home">
  <div class="overlay overlay-bg"></div>
  <div class="container">
    <div class="row d-flex align-items-center justify-content-center">
      <div class="about-content col-lg-12">
        <h1 class="text-white">
          Les formations
        </h1>
        <p class="text-white link-nav"><a routerLink="">Offres d'emploi </a> <span class="lnr lnr-arrow-right"></span> <a
            routerLink="/formations"> Les formations</a></p>
      </div>
    </div>
  </div>
</section>
<!-- End banner Area -->

<!-- Start service Area -->
<section class="service-area section-gap" id="service">
  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="col-md-8 pb-40 header-text">
        <h1>Faites vous former</h1>
        <p>
          Monter en compétence et soyez compétitif
        </p>
      </div>
    </div>

    <div class="row d-flex justify-content-center pb-4">
      <div class="serach-form-area pb-4">
        <div class="row justify-content-center form-wrap">
          <div class="col-lg-8 form-cols mb-3">
            <select class="nice-select w-100" [(ngModel)]="category">
              <option [value]="null">Toutes les catégories</option>
              <option value="{{ educationCategory['id'] }}" *ngFor="let educationCategory of educationCategoriesList">{{ educationCategory['title'] }}</option>
            </select>
          </div>
          <div class="col-lg-4 mb-3 form-cols text-center">
            <button type="button" class="btn btn-info" style="padding: 8px 15px" (click)="getEducations(category)">
              <span class="lnr lnr-magnifier"></span> Rechercher
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div class="row d-flex justify-content-center mb-4" *ngIf="isLoading">
      <span style="color: red">Chargement...</span>
    </div>

    <!-- Nb record find -->
    <div class="row d-flex justify-content-center mb-4">
      <span style="color: green">{{ educationList.length }} enregistrement (s) trouvé(s)</span>
    </div>

    <div class="row">
      <div class="col-lg-4 col-md-6" *ngFor="let education of educationList">
        <div class="single-service">
            <h4><span class="lnr lnr-license"></span>{{ education['title'] }}</h4>
            <p title="{{ education['description'] }}" style="height: 150px; overflow: auto;">
              {{ education['description'] }}
            </p>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End service Area -->